var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoulette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30C-13.431 30 0 16.569 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 457.7 266.851)",
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30C-30-13.431-16.569 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 265.333 376)",
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 16.569 13.431 30 29.999 30C46.568 30 60 16.568 60 0c0-16.569-13.431-30-30-30C13.432-30 0-16.569 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 225.333 266.666)",
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30C13.431-30 0-16.569 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 376 417.333)",
    fill: "#ffffff",
    "data-original": "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-130.339-105.661-236-236-236S-472-130.339-472 0s105.661 236 236 236S0 130.339 0 0Z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(492.098 256.012)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 86.156 69.844 156 156 156S312 86.156 312 0s-69.844-156-156-156S0-86.156 0 0Z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(100.098 256.012)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30C-13.431 30 0 16.569 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(343.276 311.861)",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30C-30-13.431-16.569 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(199 230)",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 16.569 13.431 30 29.999 30C46.568 30 60 16.568 60 0c0-16.569-13.431-30-30-30C13.432-30 0-16.569 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(169 312)",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30C13.431-30 0-16.569 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(282 199)",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-42.076-74.991m128.761-8.82-73.53-44.581m-245.088-284.962 42.076 74.991m-128.76 8.82 73.529 44.581M90.71-322.643l-74.99 42.076M6.9-409.328l-44.582 73.529M-322.643-90.71l74.99-42.077m8.821 128.761 44.581-73.529m78.287 107.867v-85.989m0-304v-84.211",
    style: {
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(372.064 462.688)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h85.988m304 0H474.2",
    style: {
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(19 255.9)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 101.823 101.823",
    style: {
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(205.095 204.957)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 101.823-101.823",
    style: {
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(205.095 306.78)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.c069fca0f7f61eea697b492e8ffff8a1.svg";
export { ForwardRef as ReactComponent };